import { AnimatedInputField } from './AnimatedInputField';
import Button from './Button';
import CheckBoxField from './CheckBoxField';
import RadioField from './RadioField';
import InputField from './InputField';
import UploadField from './UploadField';
import Agreement from './Agreement';
import Message, { MessageTypes } from './Message';
import Hint from './Hint';

export const Form = {
    AnimatedInputField,
    Button,
    CheckBoxField,
    RadioField,
    InputField,
    UploadField,
    Agreement,
    Message,
    MessageTypes,
    Hint,
};
